



















import { Component, Prop, Vue } from "vue-property-decorator";

import { REPORT_NAME_MAX_LENGTH } from "@/services/ReportNameHelper";

@Component
export default class ReportNameField extends Vue {
  @Prop({ required: true }) readonly value!: string;
  @Prop({ required: true }) readonly inputId!: string;
  @Prop({ default: null }) readonly error!: string | null;
  @Prop({ default: "Nome del template" }) readonly label!: string;
  @Prop({ default: "Es. Concorrenza TV mensile" })
  readonly placeholder!: string;
  @Prop({ default: "mb-0" }) readonly wrapperClass!: string;

  readonly maxLength = REPORT_NAME_MAX_LENGTH;

  onInput(event: Event) {
    this.$emit("input", (event.target as HTMLInputElement).value);
  }
}
